import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { parseQuery, TranslationContext } from '@pascal/pascal-core';
import { useAssetsLoadedState } from '../../hooks/useAssetsLoadedState';
import { DefaultQueryParams } from '../../core/constants/defaultQueryParams';
import { AppDefaultValuesEnum } from '../../core/constants/appDefaultValues';
import { iframeService } from '../../services/iframeService';
import { translationService } from '../../services/translationService';
import { soundService } from '../../services/baseSoundService';
import { applicationStore } from '../../store/applicationStore';

export let bodyRef;

const Loading = observer(({ children }) => {
  const { assetsIsLoaded } = useAssetsLoadedState(bodyRef);
  const { isSocketConnected } = applicationStore;
  const [soundIsLoaded, setSoundIsLoaded] = useState(false);
  const [translations, setTranslations] = useState({});

  const query = parseQuery(window.location.search);
  const lang = query[DefaultQueryParams.Culture] || AppDefaultValuesEnum.LANGUAGE;
  const partnerId = query[DefaultQueryParams.PartnerId];

  const fetchTranslation = useCallback(async () => {
    await translationService
      .getTranslations({
        applicationId: AppDefaultValuesEnum.APPLICATION_ID,
        code: lang,
        partnerId,
      })
      .then((res) => {
        setTranslations(res.data.result);
      })
      .catch(() => {
        translationService
          .getTranslations({
            applicationId: AppDefaultValuesEnum.APPLICATION_ID,
            code: AppDefaultValuesEnum.LANGUAGE,
            partnerId,
          })
          .then((res) => {
            setTranslations(res.data.result);
          });
      });
  }, [lang, partnerId]);

  const fetchSound = useCallback(async () => {
    await soundService.init({ language: lang }).then(() => setSoundIsLoaded(true));
  }, [lang]);

  useEffect(() => {
    bodyRef = document.querySelector('body');
    (async function () {
      await fetchTranslation();
      setSoundIsLoaded(true);
      await fetchSound();
    })();
  }, [fetchTranslation, fetchSound]);

  useEffect(() => {
    if (
      assetsIsLoaded &&
      Object.values(translations).length &&
      soundIsLoaded &&
      isSocketConnected
    ) {
      iframeService.sendLoadedState();
    }
  }, [assetsIsLoaded, translations, soundIsLoaded, isSocketConnected]);

  return <TranslationContext.Provider value={translations}>{children}</TranslationContext.Provider>;
});
export default Loading;
